export const KEY_PREFIX = {
  OAUTH_AUTHORIZATION: "apt_oauthauthorization_",
  OAUTH_REFRESH: "apt_oauthrefresh_",
} as const;
